import { general } from './general';

export const notapplicable = (data = {}) => general('notapplicable', data?.applicable === undefined ? { applicable: true } : data);
